<template>

    <div v-if="playbooks" class="home page">
        
            <el-table
                :data="getDefaultTableData()"
                :show-header="false"
            >
                <el-table-column
                    prop="title"   
                >
                    <span class="sectionHeader">{{getTitle()}}</span>
                </el-table-column>
            </el-table>
            <el-row :gutter="5">
                <draggable 
                    handle=".playbookHandle"
                    v-model='playbooks'
                    class="list-group" 
                    :list="playbooks" 
                    :group="{ name: 'dragPlaybook', pull: false}"
                    @change="handleClone"
                    :move="updateBoard"
                        
                >
                        <div
                            class="list-group-item"
                            v-for="element in playbooks"
                            :key="element.id"
                        >
                        <el-row class="botListItemRow">
                            <el-col :span="2">
                                {{element.id}}
                            </el-col>
                            <el-col :span="8" class="botListItemCol">
                               <div class="playbookAdvancedLink">
                                   <router-link :to="'/project/'+element.project_id+'/bot/' + element.bot_id">
                                        {{ getBotName(element.bot_id) }} 
                                   </router-link>
                                </div>
                            </el-col>
                            <el-col :span="4" class="botListItemCol">
                                <el-input-number v-loading="loading" size="mini" v-on:change="playbookChanged(element.id)" :step="50" v-model="element.goal"></el-input-number>
                            </el-col>
                            <el-col :span="6" class="botListItemCol">
                                <template>
                                <el-tooltip class="item" effect="dark" content="Edit repeats" placement="top-end">
                                
                                <el-button
                                    v-if="isPlaybookEdited(element.id)"
                                    type="success" icon="el-icon-check" circle
                                    @click="handleEdit(element.id, element)"
                                >
                                </el-button>
                                </el-tooltip>
                                <el-button-group>
                                <el-button
                                    size="mini"
                                    type="danger"
                                    icon="el-icon-delete"
                                    @click="handleDelete(element.id, element)">
                                </el-button>

                                <el-button
                                    v-if="element.advanced_settings_id==$store.state.project.advanced.data.id"
                                    size="mini"
                                    type="primary"
                                    icon="el-icon-setting"
                                    @click="playbookAdvanced(element)"
                                >
                                </el-button>
                                 <el-button
                                    size="mini"
                                    type="warning"
                                    icon="el-icon-setting"
                                    @click="playbookAdvanced(element)"
                                    v-else
                                >
                                 </el-button>
                                 </el-button-group>
                                </template>
                            </el-col>
                        </el-row>
                        <el-row>
                        </el-row>
                    </div>
                    <div class="dropzone">
                        <el-alert
                            title="Drop new bots to the section area to schedule it."
                            type="info"
                            center
                            >
                        </el-alert>
                    </div>
                </draggable>
                
            
            </el-row> 
            <el-dialog class="playbookAdvancedDialog" title="Playbook advanced settings" :visible.sync="playbookAdvancedDialog">
                <el-card class="box-card" id="recordVideo">
                    <div slot="header" class="clearfix">
                        <span>Proxy project ID, number of retries</span>
                    </div>
                    <div>
                        <el-row class="">
                            <el-col :span="1">
                                ID:
                            </el-col>
                            <el-col :span="4">
                                <el-input id="videoInt" size="mini" v-model="$store.state.project.playbookAdvanced.proxy_project_id"></el-input>
                            </el-col>
                            <el-col class="ml5" :span="4">
                                Retry num (1-5)
                            </el-col>
                            <el-col :span="5">
                                <el-input-number class="inputRetry" v-loading="loading" size="mini" :step="1" v-model="$store.state.project.playbookAdvanced.retry_num"></el-input-number>
                            </el-col>
                            <el-col :span="8">
                                Record each: <el-input-number id="videoInt" size="mini" v-model="$store.state.project.playbookAdvanced.video_num"></el-input-number>
                            </el-col>
                        </el-row>
                        <el-row>-</el-row>
                        <el-row>
                            <el-col id="OS"  :span="2">
                                OS:
                            </el-col>
                            <el-col :span="6">
                                <el-select id="firefox" v-model="$store.state.project.playbookAdvanced.device_type"  size="mini" placeholder="Select OS">
                                   
                                </el-select>
                            </el-col>   
                        </el-row>
                        <el-row>
                            <br/>
                            <el-col :span="4">Video recording</el-col>
                            <el-col :span="6"><el-input-number class="" v-loading="loading" size="mini" :step="1" v-model="$store.state.project.playbookAdvanced.video_ratio"></el-input-number></el-col>
                        </el-row>
                    </div>
                </el-card>
                <span slot="footer" class="dialog-footer">
                    <el-button type="danger" @click="resetPlaybook()">Reset to project's settings</el-button>
                    <el-button @click="playbookAdvancedDialog = false">Cancel</el-button>
                    <el-button type="primary" @click="savePlaybookAdvanced()">Save</el-button>
                </span>
            </el-dialog>
            <el-dialog v-if="view.newPlaybookDialog.entity"
                title="Schedule bot"
                :visible.sync="view.newPlaybookDialog.visible"
                width="500px"
                :before-close="handleCloseNewPlaybook"
                >
                <div class="" v-loading="loading">
                    <el-row>
                        Amount of repetitions for "{{getBotName(view.newPlaybookDialog.entity.bot_id)}}" bot.
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            
                              <el-slider
                                v-model="view.newPlaybookDialog.range"
                                range
                                show-stops
                                >
                                </el-slider>
                        </el-col>
                    </el-row>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="handleCloseNewPlaybook">Cancel</el-button>
                    <el-button icon="el-icon-danger" type="primary" @click="savePlaybook()">RUN</el-button>
                </span>
            </el-dialog>
    </div>
</template>

<style>
    .inputRetry{
        margin-top:-5px;
    }
    .settings_inactive{
        max-height: 28px;
        margin-left:5px;
    }

    .sectionHeader {
        color: grey;
        font-size: 20px;
        font-weight: bold;
    }
    .el-alert__title {
        /*color:#ccc;*/
    }
    .playbookAdvancedDialog{
       
    }

    .playbookAdvancedLink {
        cursor: pointer;
        text-decoration: underline;
    }

    .playbookAdvancedLink:hover {
        color: orange;
    }
    .ml5{
        margin-left: 10px;
    }
</style>
<script>
import { mapState, mapGetters } from 'vuex';
import draggable from 'vuedraggable';
import Vue from 'vue';

Vue.component('draggable', draggable);
export default {
    name: 'DaySection',
    components: {
        draggable
    },
    props: {
        source: {
            type: Array,
            default: () => []
        },
        sectionName: {
            type: String,
            default: 'label'
        },
        type: {
            type: String,
        },
        bots: {
            type: Array,
            default: () => []
        },
        filter: {
            
        }
    },
    watch: {
        // whenever question changes, this function will run
        filter: function (newFilter, oldFilter) {
            this.playbooks = this.getPlaybooksStore();//re-fetch data and filter it
        }
    },
    data() {
        return {  
           filteringData: {},
           playbooks: this.getPlaybooksStore(),
           playbookAdvancedDialog: false,
           playbookId: 0,
           view:{
               sort: 'asc',
               newPlaybookDialog:{
                   visible:false,
                   entity: {},
                   min: 50,
                   max: 100,
                   range: [
                       50, 100
                   ]
                   
               },
               editPlaybookDialog:{
                   visible:false,
                   entity: {}
               },
               edited:[],
                osTypes: 
                [
                    {
                        label: 'I don\t care',
                        options: 
                            [
                                {
                                    name:'Any',
                                    value:'any'
                                },
                            ]
                    },
                    {
                        label: 'Desktop systems',
                        options: 
                            [
                                {
                                    name:'Any desktop',
                                    value:'desktop_any'
                                },
                                {
                                    name:'Windows',
                                    value:'desktop_windows'
                                },
                                {
                                    name:'MacOs',
                                    value:'desktop_macos'
                                },
                                {
                                    name:'Ubuntu',
                                    value:'desktop_ubuntu'
                                },
                            ]
                    }, 
                    {
                        label: 'Mobile',
                        options: 
                            [
                                {
                                    name:'Any mobile',
                                    value:'mobile_any'
                                },
                                {
                                    name:'iOS',
                                    value:'mobile_ios'
                                },
                                {
                                    name:'Android',
                                    value:'mobile_android'
                                },
                                {
                                    name:'Popka Test',
                                    value:'mobile_popka'
                                },
                            ]
                    },
                ],
           }
        }
    },
    methods:{
        
        resetPlaybook(element) {
            //this.playbookAdvancedDialog = false;
            this.$store.dispatch('project/deletePlaybookSettings', {
                project_id: this.$route.params.id, 
                playbook_id: this.playbookId,
            });
        },
        savePlaybookAdvanced(element) {
            this.playbookAdvancedDialog = false;
            this.$store.dispatch('project/setPlaybookSettings', {
                project_id: this.$route.params.id, 
                playbook_id: this.playbookId,
                proxy_project_id: this.$store.state.project.playbookAdvanced.proxy_project_id,
                retry_num: this.$store.state.project.playbookAdvanced.retry_num,
                video_ratio: this.$store.state.project.playbookAdvanced.video_ratio,
                device_type: this.$store.state.project.playbookAdvanced.device_type,
                video_num: this.$store.state.project.playbookAdvanced.video_num
            });
        },
        playbookAdvanced(element) {
            this.playbookAdvancedDialog = true;
            this.playbookId = element.id;
            this.$store.dispatch('project/getPlaybookSettings', {
                project_id: this.$route.params.id, 
                playbook_id: element.id,
            });
        },
        playbookChanged(id) {
            this.view.edited.push(id);
        },
        handleEdit(id, element) {
            var that = this;
            var edited = this.getEditedPlaybooks(id);
            if (edited.length) {
                //save it
                that.$store.dispatch('project/updatePlaybook', {
                    project_id: this.$route.params.id, 
                    playbook_id: id,
                    goal: edited[0].goal
                });
            }
        },

        getEditedPlaybooks(id) {
            var that = this;
            var edited = [];
            if (that.view.edited.indexOf(id) == -1) {//if our item is in the list of edited - let it be saved.
                return edited;
            }

            edited = this.playbooks.filter(function(item){
                if (item.id == id) return item;
            });

            return edited;
        },
        isPlaybookEdited(id) {
            var edited = this.getEditedPlaybooks(id);
            if (edited.length) {
                return true;
            }

            return false;
        },
        handleDelete(id, element) {
            var that = this;
            this.$confirm('This will permanently delete the playbook. Continue?', 'Warning', 
            {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                that.$store.dispatch('project/deletePlaybook', {
                    project_id: this.$route.params.id, 
                    playbook_id: id,
                });
            /*this.$message({
                type: 'success',
                message: 'Delete completed'
            });*/
            }).catch(() => {
            this.$message({
                type: 'info',
                message: 'Delete canceled'
            });          
            });
        },
        handleCloseNewPlaybook() {
            //this.view.newPlaybookDialog.visible = false;
            //this.view.newPlaybookDialog.entity = {};
            //this.dropNewPlaybooks();
        },
        dropNewPlaybooks() {
            this.playbooks = this.playbooks.filter(playbook => playbook.id != 'new');
        },
        savePlaybook() {
            var that = this;
            this.$store.dispatch('project/createPlaybook', {
                project_id: this.$route.params.id, 
                bot_id: that.view.newPlaybookDialog.entity.bot_id,
                time_of_days: that.type,
                goal: that.view.newPlaybookDialog.range[0]
            });
        },
        handleClone(evt) {
            var eventKey = Object.keys(evt)[0];
            
            if (eventKey == 'added') {
                //fireup scheduling
                this.view.newPlaybookDialog.entity = evt.added.element;
                this.view.newPlaybookDialog.visible = true;
            }
        },
        updateBoard(evt) {
            
        },

        getDefaultTableData() {
            return [
                {
                    title: 'date_section',
                    value: this.type
                }
            ]
        },
       
        getTitle() {
            return this.sectionName;
        },
        botNameFormatter(row, column) {
            return this.getBotName(row.bot_id);
        },
        dayTimeFormatter(row, column) {
            switch (row.time_of_days) {
                case 'any' : return 'Whole day';
                case 'now' : return 'Immediate';
                case 'night' : return 'Night';
                case 'day' : return 'Day';
                case 'morning' : return 'morning';
                default: return row.time_of_days;
            }
        },
        
        getBotName(id) {
            if (id === undefined) return '';
            //there is bots props with complete set of project's bots
            var data = this.bots.filter(
                bot => bot.id == id
            );

            return (data[0] == undefined) ? 'unknown bot' : data[0].name;
        },
        getPlaybooksStore() {
            var toFilter = this.$store.state.project.playbooks.data.filter(playbook => playbook.time_of_days == this.type);
            var result = toFilter;
             if (this.filter) {
                //step one: find bots
                var bots = this.bots.filter(
                function(bot){
                    if (bot.name.toLowerCase().indexOf(this.filter.toLowerCase()) != -1) {
                        return true;
                        }
                    }, this
                );
                //step two: find them by ids in playbooks
                this.filteringData.bots = bots;
                result = toFilter.filter(
                function(playbook){
                    for (var i=0;i<this.filteringData.bots.length;i++) {
                        if (playbook.bot_id == this.filteringData.bots[i].id) {
                            return true;
                        }
                    }
                }, this
                );
            }

            return result;
            /*return result.sort(
                var that = this;
                function(a, b){
                    var aName = that.getBotName()
                    if(a.firstname < b.firstname) { return -1; }
                    if(a.firstname > b.firstname) { return 1; }
                    return 0;
                }
            );*/
            
        },
        sortPlaybooks() {
            //getBotName(element.bot_id)
            
        }
    },
    components:{

    },
    mounted: function() {
        var that = this;
        this.$store.subscribe((mutation, state) => {
            if (mutation.type === 'project/CREATE_PLAYBOOK_RESPONSE_DATA' &&
                mutation.payload.time_of_days == that.type //if somebody saved playbook for this section - update its data
            ){
                that.playbooks = that.getPlaybooksStore();//re-fetch data from playbooks
                that.view.newPlaybookDialog.visible = false;
            }

            if (mutation.type === 'project/DELETE_PLAYBOOK_RESPONSE_DATA' &&
                mutation.payload.time_of_days == that.type) {
                that.playbooks = that.getPlaybooksStore();
            }

            if (mutation.type === 'project/UPDATE_PLAYBOOK_RESPONSE_DATA' &&
                mutation.payload.time_of_days == that.type) {
                that.view.edited = that.view.edited.filter(id => id !== mutation.payload.id);                
            }
            
            if (mutation.type === 'project/DELETED_PLAYBOOK_ADVANCED') {
                that.playbookAdvancedDialog = false;
            }
        })
    },
    computed: {
        ...mapState('project', {
        error: 'error',
        loading: 'loading',
        }),
        ...mapGetters('project', [
        'isEmpty'
        ]),
    }
}
</script>